import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EmpoweringColoradosFuture from "./sections/EmpoweringColoradosFuture";
import EconomicImpactDashboard from "./sections/EconomicImpactDashboard";
import OurLegacyOfImpact from "./sections/OurLegacyOfImpact";
import PillarsOfProsperity from "./sections/PillarsOfProsperity";
import CommunityPulseEvents from "./sections/CommunityPulseEvents";
import JoinTheMovement from "./sections/JoinTheMovement";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <EmpoweringColoradosFuture />
      <EconomicImpactDashboard />
      <OurLegacyOfImpact />
      <PillarsOfProsperity />
      <CommunityPulseEvents />
      <JoinTheMovement />
      <FooterInformation />
    </div>;
}